import Vue from 'vue';
import GAuth from 'vue-google-oauth2';

import ENV from '@/config/environment';
import { writeCookie, deleteCookie } from '@/helpers/helpers';

const ThirdPartyAuthInit = () => {
  (function () {
    if(!document.getElementById('FBsdk')) {
      var script = document.createElement('script');
      script.setAttribute('src', '//connect.facebook.net/en_US/sdk.js');
      script.setAttribute('id', 'FBsdk');
      script.setAttribute('type', 'application/javascript');
      script.addEventListener('load', function(){
        FB.init({
          appId: ENV.facebook.fbAppId,
          version: ENV.facebook.fbVersion
        });
        FB.getLoginStatus(async function(fbResponse) {
          if (fbResponse.status === 'connected') {
            writeCookie('facebookAccessToken', fbResponse.authResponse.accessToken);
          } else {
            deleteCookie('facebookAccessToken');
          }
        });
      });
      document.head.appendChild(script);
    }
  }());

  Vue.use(GAuth, {
    client_id: ENV.google_clientId,
    scope: 'email profile openid',
    response_type: 'id_token token',
    prompt: 'select_account'
  });
};

export default ThirdPartyAuthInit;
